/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {AddField} from './addField';
import {FilterConf} from './filterConf';
import {GroupConf} from './groupConf';


export interface AbstractExtractConf {
    addFields?: Array<AddField>;
    cron?: string;
    enableSchedule?: boolean;
    filtersExtract?: Array<FilterConf>;
    group?: GroupConf;
    scriptPostMapping?: string;
    typeImport?: AbstractExtractConf.TypeImportEnum;
    typeObject?: string;
    updateImportFieldChangeDetection?: Array<string>;
    updateImportFieldSearch?: Array<string>;
}

export namespace AbstractExtractConf {
    export type TypeImportEnum = 'ADD' | 'UPDATE';
    export const TypeImportEnum = {
        ADD: 'ADD' as TypeImportEnum,
        UPDATE: 'UPDATE' as TypeImportEnum
    };
}
